import { useState, useEffect, useContext } from "react";
import calenderIcon from "../../assets/calender-icon.svg";
import uplaodIcon from "../../assets/upload-green-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import saveIcon from "../../assets/save-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";
import { CaseServices } from "../../services/CaseServices";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { useLocation } from "react-router-dom";
// const getScrapData = (latestStageData) => {
//   const scrapData = latestStageData?.documents?.filter((doc) =>
//     doc?.documentName?.toLowerCase()?.includes("hospital bill"),
//   )?.[0]?.scrapData;
// };
const formatDateForInput = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);

  const y = parts.find((p) => p.type === "year").value;
  const m = parts.find((p) => p.type === "month").value;
  const day = parts.find((p) => p.type === "day").value;

  return `${y}-${m}-${day}`;
};

const HospitalBillDetailsForm = ({ data, caseStage }) => {
  const { caseDetails, latestStageData } = useContext(CaseStageContext);
  console.log("latest stage data from bill details:", latestStageData);
  const [documentId, setDocumentId] = useState(null);
  const [hospitalBillNumber, setHospitalBillNumber] = useState("");
  const [billDate, setBillDate] = useState("");
  const [hospitalBillAmount, setHospitalBillAmount] = useState("");
  const [hospitalBillFile, setHospitalBillFile] = useState(null);
  const [dischargeDetails, setDischargeDetails] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const location = useLocation();
  const [formData, setFormData] = useState({
    billNo: null,
    billDate: null,
    billAmount: null,
  });
  const handleUpdate = async () => {
    const data = {
      scrapData: {
        ...formData,
        billDate: new Date(formData?.billDate)?.toISOString(),
      },
    };
    try {
      const res = CaseServices?.updateDocumentScrapData(data, documentId);
      console.log("res data:", res?.data);
      setIsEditMode(false);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    if (!latestStageData) return;
    const data = latestStageData?.documents?.filter((doc) =>
      doc?.documentName?.toLowerCase()?.includes("hospital bill"),
    )?.[0];
    setFormData(data?.scrapData?.current);
    setDocumentId(data?.id);
  }, [latestStageData]);

  console.log("form data:", formData);
  console.log("doc Id:", documentId);
  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />

      <div className="pt-[30px]">
        <div className="grid grid-cols-3 2xl:grid-cols-4 gap-[6px] 2xl:gap-[4px] 3xl:gap-3 pt-[30px]">
          {/* Hospital Bill Number */}
          <div className="relative ">
            <input
              type="text"
              value={formData?.billNo}
              disabled={!isEditMode}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  billNo: e.target.value,
                }))
              }
              placeholder="Hospital Bill Number"
              className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[110px] outline-none placeholder:font-lufga placeholder:font-normal placeholder:text-[14px] placeholder:leading-[12px] placeholder:tracking-[-0.03em]"
            />

            {/* {formData.temperature && (
              <span className="absolute right-[32px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
                Temperature
              </span>
            )} */}
          </div>

          {/* Bill Date */}
          <div className="relative ">
            <input
              type="date"
              value={formatDateForInput(formData?.billDate)}
              disabled={!isEditMode}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  billDate: e.target.value,
                }))
              }
              placeholder="Bill Date*"
              className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[110px] outline-none placeholder:font-lufga placeholder:font-normal placeholder:text-[14px] placeholder:leading-[12px] placeholder:tracking-[-0.03em]"
            />

            {/* {formData.temperature && (
              <span className="absolute right-[32px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
                Temperature
              </span>
            )} */}
          </div>

          {/* Hospital Bill Amount */}
          <div className="relative ">
            <input
              type="text"
              value={formData?.billAmount}
              disabled={!isEditMode}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  billAmount: e.target.value,
                }))
              }
              placeholder="Hospital Bill Amount"
              className="w-full h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent pl-[32px] pr-[110px] outline-none placeholder:font-lufga placeholder:font-normal placeholder:text-[14px] placeholder:leading-[12px] placeholder:tracking-[-0.03em]"
            />

            {/* {formData.temperature && (
              <span className="absolute right-[32px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
                Temperature
              </span>
            )} */}
          </div>

          {/* Upload Hospital Bill */}
          <div className="w-full h-[90px] xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent px-[22px] flex items-center">
            <input
              type="file"
              id="hospitalBillUpload"
              className="hidden"
              onChange={(e) => setHospitalBillFile(e.target.files?.[0] || null)}
            />

            <label
              htmlFor="hospitalBillUpload"
              className="w-full cursor-pointer flex items-center justify-between"
            >
              <span className="font-lufga font-normal text-[14px] text-[#8B8B8B]">
                Upload Hospital Bill
              </span>

              <img src={uplaodIcon} alt="upload" width={16} height={16} />
            </label>
          </div>
        </div>
      </div>

      {!location?.pathname?.toLowerCase()?.includes("editcases") && (
        <div>
          {isEditMode ? (
            <div className="flex justify-end mt-[12px]">
              <button
                className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px] 2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal"
                onClick={handleUpdate}
                // disabled={isSubmitting}
              >
                SAVE
                <img src={saveIcon} alt="save" className="pl-[16px]" />
              </button>
            </div>
          ) : (
            <div className="flex justify-end items-center gap-[10px] mt-[12px]">
              <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
                SAVED
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13L9 17L19 7"
                    stroke="white"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <button
                onClick={() => setIsEditMode(true)}
                className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent"
              >
                <img src={editIcon} alt="edit icon" width={9} height={18} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HospitalBillDetailsForm;
